import i18n from 'i18next'

export const lang = {
  isEnglish: () => i18n.language === 'en',
}
